<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="赠送记录" name="first"></el-tab-pane>
            <el-tab-pane label="收礼记录" name="second"></el-tab-pane>
        </el-tabs>
        <!-- 表格 -->
        <el-table class="columnClassNav" align="center" :data="tableData" border>
            <el-table-column label="发送用户" align="center" show-overflow-tooltip>
                <template slot-scope="tableData">
                    <div style="display: flex;align-items: center;justify-content: center;">
                        <el-image style="width: 40px; height: 40px; border-radius: 50%;"
                            :src="tableData.row.userPicture" fit="cover"></el-image>
                        <div style="margin-left: 20px;">{{ tableData.row.name }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="messageContent" label="私信内容" align="center">
                <template slot-scope="tableData">
                    <div v-if="tableData.row.messageType == 1">{{ tableData.row.messageContent }}</div>
                    <el-image v-else style="width: 60px; height: 60px;"
                        :preview-src-list="[tableData.row.messageContent]" :src="tableData.row.messageContent"
                        fit="cover"></el-image>
                </template>
            </el-table-column>

            <el-table-column label="接收用户" align="center" show-overflow-tooltip>
                <template slot-scope="tableData">
                    <div style="display: flex;align-items: center;justify-content: center;">
                        <el-image style="width: 40px; height: 40px; border-radius: 50%;"
                            :src="tableData.row.friendUserPictrue" fit="cover"></el-image>
                        <div style="margin-left: 20px;">{{ tableData.row.friendUserNickName }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="messageType" label="消息类型" align="center">
                <template slot-scope="tableData">
                    <span :style="{ color: tableData.row.messageType == 1 ? '#3bb4f2' : '#5eb95e' }">
                        {{ tableData.row.messageType == 1 ? '文字' : '图片' }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="createTime" label="发送时间" align="center">
            </el-table-column>
        </el-table>

        <div style="text-align: right;margin: 20px 20px 0 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import '@/assets/icon/iconfont.css'
import { getGiftRecordPage } from '@/api/gift'
export default {
    name: 'messageList',
    props: {
        userId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            tableData: '',
            // 对话框
            total_pages: 0,
            params: { pageNum: 1, pageSize: 10 },
            activeName: 'first',
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            let options = {
                pageNum: this.params.pageNum,
                pageSize: this.params.pageSize,
            }
            if (this.activeName == 'first') {
                options.userid = this.userId;
            } else {
                options.giverUserid = this.userId;
            }
            getGiftRecordPage(options).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.total_pages = res.data.total;
                } else {
                    this.$message.error(res.msg || '获取礼物记录列表失败');
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取礼物记录列表失败');
            })
        },
        openModal(title, row) {
            this.$refs.detailRef.open(title, row)
        },
        handleCurrentChange(number) {
            this.params.pageNum = number;
            this.getData();
        },
        handleSizeChange(size) {
            if (this.total_pages >= size) {
                this.params.pageSize = size;
                this.getData();
            }
        },
        handleClick(tab) {
            this.activeName = tab.name;
            this.params.pageNum = 1;
            this.getData();
        }
    }
}
</script>

<style scoped lang="scss">
.elTableBox {
    display: flex;
    width: 100%;
}
</style>
